export default __webpack_public_path__ + "static/media/IMG_9951.d4c16f39.webp";